import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import { api } from '../helper/api';
import { IPFStoURL, formatPrice, getCurrentChain } from '../helper/functions';
import { Link, useLocation } from 'react-router-dom';
import Countdowncomp from '../components/Countdowncomp';
import { CHAIN_INFO, DEFAULT_IMAGES } from '../helper/constant';
import { useAccount } from 'wagmi';


export default function ExploreNft() {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [collectionData, setCollectionData] = useState([]);
    const [orderBy, setOrderBy] = useState('desc');
    const [orderById, setOrderById] = useState('id');
    const [page, setPage] = useState(1);
    const [perpage, setPerpage] = useState(10)
    const [search, setSearch] = useState('')
    const [totalpages, setTotalpages] = useState(0);
    const [saleType, setSaletype] = useState(location.state?.saleType || '');
    const [saleId, setSaletid] = useState(location.state?.saleId || '');
    const [orderByName, setOrderByName] = useState('DESC By Created')
    const { chainId } = useAccount();
    const currentChain = getCurrentChain(chainId);


    const handlePageChange = (nextpage) => {
        let newPage;

        if (nextpage === 'prev' && parseInt(page) - 1 >= 1) {
            newPage = Math.max(1, parseInt(page) - 1);
        } else if (nextpage === 'next' && parseInt(page) < parseInt(totalpages)) {
            newPage = Math.min(parseInt(totalpages), parseInt(page) + 1);
        } else {
            newPage = parseInt(nextpage);
        }

        if (newPage !== parseInt(page)) {
            setPage(newPage);
        }
    };

    useEffect(() => {
        async function fetch() {
            const response = await api.get('nft/listed', {
                params: {
                    page,
                    limit: perpage,
                    order_by: orderBy,
                    order_id: orderById,
                    saletype: saleId
                }
            })



            if (response && response.data && response.data.error === 'OK') {
                console.log(response.data.data)
                setCollectionData(response.data.data);
                setTotalpages(response.data.totalPages)
            }
            setLoading(false);

        }

        fetch();
    }, [perpage, orderBy, saleId, search, page, orderById]);


    return (
        <Layout>
            <section class="jarallax text-light pb-4">
                <div class="center-y relative text-center">
                    <div class="container">
                        <div class="row">

                            <div class="col-md-12 text-center">
                                <h1>Explore NFTs</h1>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='pt-1'>
                <div class="container">
                    <div class="row wow fadeIn">
                        <div class="col-lg-12">

                            <div class="items_filter">
                                <form action="#sec" class="row form-dark" id="form_quick_search">
                                    <div class="col text-center">
                                        <input class="form-control" value={search} onChange={(e) => setSearch(e.target.value)} name="search" placeholder="search item by name or symbol here..." type="text" /> <a href="#sec" id="btn-submit"><i class="fa fa-search bg-color-secondary"></i></a>
                                        <div class="clearfix"></div>
                                    </div>
                                </form>


                                <div class="btn-group mx-2">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        {orderByName ? orderByName : 'DESC By Created'}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('desc')
                                            setOrderById('id')
                                            setOrderByName('DESC By Created')
                                        }}><span>DESC By Created</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('asc')
                                            setOrderById('id')
                                            setOrderByName('ASC By Created')
                                        }}><span>ASC By Created</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('asc')
                                            setOrderById('price')
                                            setOrderByName('ASC By Price')
                                        }}><span>ASC By Price</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setOrderBy('desc')
                                            setOrderById('price')
                                            setOrderByName('DESC By Price')
                                        }}><span>DESC By Price</span></li>
                                    </ul>
                                </div>

                                <div class="btn-group mx-2">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        {perpage ? perpage : 'Per Page Items'}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li class="dropdown-item" onClick={() => setPerpage(10)}><span>10</span></li>
                                        <li class="dropdown-item" onClick={() => setPerpage(20)}><span>20</span></li>
                                        <li class="dropdown-item" onClick={() => setPerpage(30)}><span>30</span></li>
                                    </ul>
                                </div>

                                <div class="btn-group mx-2">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        {saleType ? saleType : 'All'}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li class="dropdown-item" onClick={() => {
                                            setSaletid('')
                                            setSaletype('All')
                                        }}><span>All</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setSaletid(1)
                                            setSaletype('On Sale')
                                        }}><span>On Sale</span></li>
                                        <li class="dropdown-item" onClick={() => {
                                            setSaletid(2)
                                            setSaletype('On Auction')
                                        }}><span>On Auction</span></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        {loading ? (
                            <>Loader</>
                        ) : (
                            <>
                                {collectionData && collectionData.map((items, key) => {
                                    let metadata = items.metaData ? JSON.parse(items.metaData) : {};
                                    let currencyInfo = CHAIN_INFO[currentChain].currency_support.filter((values) => items.ERC20Token && values.address.toLowerCase() === items.ERC20Token.toLowerCase())
                                    items.currencyInfo = currencyInfo.length > 0 ? currencyInfo[0] : CHAIN_INFO[currentChain].currency_support[0];
                                    
                                    return (
                                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={key}>
                                            <div class="nft__item">
                                                {items.saletype === "2" &&
                                                    <Countdowncomp timestamp={items.auctionEnd} />
                                                }

                                                <div class="author_list_pp">
                                                    <a href="#sec" data-bs-toggle="tooltip" data-bs-placement="top" title="Creator: Stacy Long">
                                                        <img class="lazy" src={items.user_profile ? IPFStoURL(items.user_profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt="profile" />
                                                        <i class="fa fa-check"></i>
                                                    </a>
                                                </div>
                                                <div class="nft__item_wrap">
                                                    <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                        <img src={IPFStoURL(metadata?.['image'])} class="nft__item_preview" alt="static" />
                                                    </Link>
                                                </div>
                                                <div class="nft__item_info p-2">
                                                    <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                        <h4>{metadata.name ? metadata.name : `${items.col_name}`} #{items.tokenId}</h4>
                                                    </Link>
                                                    <div className='d-flex justify-content-between '>
                                                        <div class="nft__item_price">
                                                            <span>{items.nftHighestBid > 0 ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : formatPrice(items.price / Math.pow(10, 18))} {items.currencyInfo.symbol}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                {collectionData && collectionData.length > 0 &&
                                    <div className='col-12 d-flex justify-content-center'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination pagination">
                                                <li>
                                                    <button

                                                        disabled={parseInt(page) === 1 || parseInt(page) === 0} // Disable if on the first page
                                                        onClick={() => handlePageChange('prev')}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>
                                                {Array.from({ length: totalpages }, (_, index) => (
                                                    <li key={index}>
                                                        <button
                                                            className={`${page === index + 1
                                                                ? 'active'
                                                                : ''
                                                                }`}
                                                            onClick={() => handlePageChange(index + 1)}
                                                        >
                                                            {index + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                                <li>
                                                    <button
                                                        disabled={parseInt(page) === parseInt(totalpages)} // Disable if on the last page
                                                        onClick={() => handlePageChange('next')}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                }
                            </>

                        )}
                    </div>
                </div>
            </section>
        </Layout>
    )
}
